import React from 'react';
import styled from 'styled-components';
import { NavLink, NavLinkProps } from 'react-router-dom';

const Styled = {
  ModeButton: styled(NavLink)`
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: max-content;
    margin-right: 30px;
    padding: 0 3px;
    font-size: 14px;
    font-weight: normal;
    color: #333333;
    text-decoration: none;
    cursor: pointer;
    height: 100%;

    &.active {
      border-bottom: 2px solid #003a72;
      font-weight: bold;
    }

    :last-child {
      margin-right: 0;
    }
  `,
};

type Props = NavLinkProps;

const ModeButton: React.FC<Props> = ({ children, ...props }) => {
  return <Styled.ModeButton {...props}>{children}</Styled.ModeButton>;
};

export default ModeButton;
